export const promoCodeList = {
    BOGO: 'BOGO',
    BMSM2022: 'BMSM2022',
}

export const BMSM2022_CATEGORY = 'cabinets'
